module.exports = __webpack_public_path__ + "media/icons/szkody-pojazdu-12b11600.svg";